(function() {
    angular.module('adminApp.auth', [
        'authApp'
    ]);
})();
